import React from 'react'
import { CircularProgress } from '@material-ui/core'

import { formatDashboardNumber } from '../../NewDashboard/utils/formatDashboardNumber'
import { ReviewStats } from './types'

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

const STAR_LEVELS: Array<1 | 2 | 3 | 4 | 5> = [5, 4, 3, 2, 1]

interface StarDistributionProps {
  stats: ReviewStats | null
  isLoading?: boolean
  className?: string
}

export const StarDistribution: React.FC<StarDistributionProps> = ({
  stats,
  isLoading = false,
  className = '',
}) => {
  const totalCount = stats?.totalCount ?? 0

  return (
    <div
      className={`bg-white rounded-2xl p-6 flex flex-col overflow-hidden ${className}`}
      style={montserratStyle}
    >
      <span className="text-base font-bold mb-4">Distribución por valoración</span>
      {isLoading ? (
        <CircularProgress size={24} />
      ) : (
        <div className="flex flex-col gap-3">
          {STAR_LEVELS.map(stars => {
            const count = stats?.distribution[stars] ?? 0
            const widthPercent = totalCount > 0 ? (count / totalCount) * 100 : 0

            return (
              <div key={stars} className="flex items-center gap-3">
                <span className="text-sm font-semibold w-16 shrink-0">{stars} estrellas</span>
                <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className="h-full rounded-full"
                    style={{ width: `${widthPercent}%`, background: '#47B960' }}
                  />
                </div>
                <span className="text-sm text-gray-700 w-24 shrink-0 text-right">
                  {formatDashboardNumber(count)} reseñas
                </span>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

StarDistribution.defaultProps = {
  isLoading: false,
  className: '',
}
